export default __webpack_public_path__ + "static/media/Potion of Strength (4h).f0c67f33.jpg";